import { strings } from "@quickpoint.me/shared";
import { PageSizeAtomType } from "../@types/viewerati";

function getElementsNotInGrids(container: HTMLElement) {
  const elementsInGrid = Array.from(container.querySelectorAll(
    `${strings.css.gridClass}  ${strings.css.pageElementClass}`,
  ));

  const allPageElements = Array.from(
    container.querySelectorAll(
      `:not(.backdrop):not(.background)${strings.css.pageElementClass}`,
    ),
  );
  // elements on the page that are outside any grid
  const difference = allPageElements.filter(x => !elementsInGrid.includes(x));

  return difference as HTMLElement[];
}

function getHeightWithMargins(el: HTMLElement) {
  var styles = window.getComputedStyle(el);
  var margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);
  return Math.ceil(el.offsetHeight + margin);
}

function findFreeVerticalSpaceWithGrid(
  thisElRef: React.RefObject<HTMLDivElement>,
  rows: number,
  pageSize: PageSizeAtomType,
  container: HTMLElement,
) {
  // it's in a grid column. Find the parent and calculate size using that.
  const thisEl = thisElRef.current;
  const containingGridCell = thisEl?.closest(strings.css.styledGridCellClass);
  let notImagesInContainingGridCelsvh = 0;
  let elementsNotInGrisvh = 0;

  const numberOfImagesInContaininggGridCell = containingGridCell
    ? containingGridCell.querySelectorAll(strings.css.dynamicResizeClass).length
    : 0;

  const notImagesInContainingGridCell = containingGridCell
    ? containingGridCell.querySelectorAll(
      ":not(.image):not(.video):not(.backdrop):not(.background).page-element",
    ) as NodeListOf<HTMLDivElement>
    : [];

  if (notImagesInContainingGridCell.length > 0) {
    notImagesInContainingGridCell.forEach((el: HTMLElement) => {
      notImagesInContainingGridCelsvh += getHeightWithMargins(el);
    });
  }

  if (getElementsNotInGrids(container).length > 0) {
    getElementsNotInGrids(container).forEach(el => {
      elementsNotInGrisvh += getHeightWithMargins(el);
    });
  }

  return [
    ((pageSize.height - elementsNotInGrisvh) / rows) - notImagesInContainingGridCelsvh,
    numberOfImagesInContaininggGridCell,
  ];
}

export function findFreeVerticalSpace(
  thisElRef: React.RefObject<HTMLDivElement>,
  rows: number,
  pageSize: PageSizeAtomType,
  containerSelector: string,
) {
  const container = document.getElementById(containerSelector);
  if (!container) {
    throw ("Container element does not exist");
  }
  const grid = container.querySelectorAll(strings.css.gridClass);

  if (grid.length > 0) {
    return findFreeVerticalSpaceWithGrid(thisElRef, rows, pageSize, container);
  }

  const firstElement = container.getElementsByClassName(strings.css.pageElement)[0];

  if (!firstElement || firstElement === null) return [0, 0];

  const numberOfImages = container.querySelectorAll(strings.css.dynamicResizeClass).length;

  let notImages = container.querySelectorAll(
    `:not(.image):not(.video):not(.backdrop):not(.background)${strings.css.pageElementClass}`,
  ) as NodeListOf<HTMLDivElement>;

  let notImagesVH = 0;

  if (notImages.length > 0) {
    notImages.forEach((el: HTMLElement) => {
      var styles = window.getComputedStyle(el);
      var margin = parseFloat(styles["marginTop"])
        + parseFloat(styles["marginBottom"]);
      notImagesVH += Math.ceil(el.offsetHeight + margin);
    });
  }

  return [pageSize.height / rows - notImagesVH, numberOfImages];
}
